const ALLOWED_STATUS = new Set(['no_documents', 'digitized']);

const isJobDeletable = (jobStatus: string): boolean => {
  return ALLOWED_STATUS.has(jobStatus) ? true : false;
};

export default isJobDeletable;
